import axios from 'axios';
import { API_ENDPOINTS } from '../../apiConfig';

export interface Contract {
    id: string;
    bidId?: string;
    contractName?: string;
    referenceNo?: string;
    description?: string;
    status?: string;
    paperCost?: number;
    tenderActualValue?: number;
    tenderBidValue?: number;
    tenderBidPercentage?: number;
    contractType?: string;
    terminationReason?: string;
    extensionCoun?: number;
    openingDate?: string;
    closingDate?: string;
    resultDate?: string;
    draftingDate?: string;
    submittedPaymentDate?: string;
    awardedDate?: string;
    aggreementDate?: string;
    givenStartDate?: string;
    givenEndDate?: string;
    actualStartDate?: string;
    actualEndDate?: string;
    licenseId?: string;
    licenseHolderName?: string;
    licenseNo?: string;
    comments?: string;
    contractMetadata?: any; // JSONB
    createdBy?: string;
    updatedBy?: string;
    createdAt?: string;
    updatedAt?: string;
    isDeleted?: boolean;
    deletedAt?: string;
    deletedBy?: string;
  }
  
  

export interface PaginatedResponse<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  number: number; // current page
  size: number;
}

export interface DateRange {
  from?: string;
  to?: string;
}

export interface ContractFilterRequest {
  contractName?: string;
  bidId?: string;
  referenceNo?: string;
  status?: string[];
  licenseHolderName?: string;
  contractType: '',
  dateRange?: DateRange;
  pagination: {
    page: number;
    size: number;
  };
  sort: {
    field: string;
    direction: 'asc' | 'desc';
  };
}

export interface ContractDeposit {
  id: string;
  bidId: string;
  contractName: string;
  description?: string;
  tenantId?: string;
  tenantName?: string;
  referenceNo: string;
  status: string;
  paperCost: number;
  totalDeposit: number;
  totalAmount: number;
  licenseHolderName?: string;
  submittedPaymentDate: string;
  contractType?: string;
  tenderActualValue?: number;
  tenderBidValue?: number;
  tenderBidPercentage?: number;
  givenStartDate?: string;
  givenEndDate?: string;
  actualStartDate?: string;
  actualEndDate?: string;
  isProjectCreated?: boolean;
}

 
export interface ContractDepositFilter {
  depositType?: string;
  accountHolderName?: string;
  bankAccountNo?: string;
  depositStatuses?: string[];
  bidId: string;
  contractName: string;
  referenceNo: string;
  description?: string;
  statuses: string[];
  contractType?: string;
  licenseHolderName: string;
  pagination: { page: number; size: number };
}

const API_BASE =  `${API_ENDPOINTS.platform}/contracts`;
const API_DASBOARD = `${API_ENDPOINTS.platform}/contract-dashboard`;
 

export const fetchContracts = () => {
  return axios.get<Contract[]>(API_BASE);
};

export const fetchContractById = (id: string) => {
  return axios.get<Contract>(`${API_BASE}/${id}`);
};

export const createContract = (contract: Partial<Contract>) => {
  return axios.post<Contract>(API_BASE, contract);
};

export const updateContract = (id: string, contract: Partial<Contract>) => {
  return axios.put<Contract>(`${API_BASE}/${id}`, contract);
};

export const deleteContract = (id: string) => {
  return axios.delete(`${API_BASE}/${id}`);
};

export const fetchFilteredContracts = (filter: ContractFilterRequest) => {
  return axios.post<PaginatedResponse<Contract>>(`${API_BASE}/filter`, filter);
};

export const getContractStats = () => {
    return axios.get(`${API_BASE}/stats`);
  };

  export const bulkUploadContracts = async (file: File) => {
  const formData = new FormData();
  formData.append('file', file);    
  const response = await axios.post(`${API_BASE}/v2/bulk-upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }); 
  return response;
};


export const getContractStatusSummary = () =>
  axios.get(`${API_DASBOARD}/status-summary`);

export const getContractCategorySummary = () =>
  axios.get(`${API_DASBOARD}/status-category-summary`);


export const fetchContractDeposits = async (filterRequest: any) => {
  const response = await axios.post(`${API_ENDPOINTS.platform}/contracts-deposit/search`, filterRequest);
  return response.data;
};



export interface ContractKpiRequest {
  tenantId?: string;
  fromDate?: string;  // format: 'YYYY-MM-DD'
  toDate?: string;    // format: 'YYYY-MM-DD'
  timePeriod?: string; // e.g., 'last_6_months', 'last_12_months'
}

export const fetchContractKpis = async (params?: ContractKpiRequest) => {
  const response = await axios.post(`${API_DASBOARD}/kpis`, params || {});
  return response.data;
};